// extracted by mini-css-extract-plugin
export default {"leftfix":"reset_leftfix__yK8SH","rightfix":"reset_rightfix__HKMf4","clearfix":"reset_clearfix__eKr-U"};